
import { Options } from "vue-class-component";
import { ScreenType } from "../../enum/screen.type";
import AuthService from "../../services/auth.service";
import RouterService from "../../services/router.service";
import Base from "./../base/Base.vue";
import LoginGoogle from "../loginWithSocialNetwork/LoginGoogle/LoginGoogle.vue";
@Options({
  components: {
    LoginGoogle
  }
})
export default class LoginWithSocialNetwork extends Base {
  signWithGoogle() {
    AuthService.signWithGoogle().subscribe(result => {
      if (result) {
        RouterService.redirectTo(ScreenType.hall);
      }
    });
  }

  signWithFacebook() {
    AuthService.signWithFacebook().subscribe(result => {
      if (result) {
        RouterService.redirectTo(ScreenType.hall);
      }
    });
  }

  signOut() {
    AuthService.signOut();
  }
}
